import { ReactElement, ReactNode, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../../Button'
import { NavListSeparator } from '../../../../../NavList'
import { Text } from '../../../../../Text'
import { useComboBox } from '../../../../contexts/comboBoxContext'

interface AddNewItemButtonProps {
  children?: ReactNode
}

export const AddNewItemButton = ({ children }: AddNewItemButtonProps): ReactElement => {
  const { t } = useTranslation()
  const { addValueToSelected, items } = useComboBox()

  const shouldShowSeparator = !!items.length

  const handleButtonClick = useCallback(() => {
    addValueToSelected()
  }, [addValueToSelected])

  const defaultAddItemLabel = t('ds.combobox.add_item')

  const buttonTitle = useMemo(() => {
    if (typeof children === 'string') {
      return children
    }

    if (!children) {
      return defaultAddItemLabel
    }

    return undefined
  }, [children, defaultAddItemLabel])

  return (
    <>
      {shouldShowSeparator && <NavListSeparator />}
      <Button title={buttonTitle} icon="circlePlus" variant="text" fullWidth onClick={handleButtonClick}>
        {children || (
          <Text as="span" inherit truncate>
            {defaultAddItemLabel}
          </Text>
        )}
      </Button>
    </>
  )
}
